import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';

import './index.scss';

const b = b_.with('position-details-footer');

export const Footer: React.FC = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className={b()} data-testid="footer">
      <div className={b('inner')}>
        <div className={b('title')}>{t('Total including commissions')}</div>
        {children}
      </div>
    </div>
  );
};
